// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"75f10e6b","455":"3bab9635","977":"a211a17d"}[chunkId] + ".chunk.js";
};